import React, { useState } from "react";
import DateFilter from "./date";

const AppointmentFilter = (props) => {

  const [currentElementId, setCurrentElementId] = useState("");
  const [appointmentStatus, setAppointmentStatus] = useState("");
  const [allAppointmentStatus, setAllAppointmentStatus] = useState(["Completed", "Pending", "Cancelled", "Rescheduled"]);

  const [appointmentType, setAppointmentType] = useState("");
  const [allAppointmentTypes, setAllAppointmentTypes] = useState(["Nutrition", "Body Composition", "Fitness Test", "Rehabilitation", "Health"]);
  
  const [isReportGenerated, setReportGenerated] = useState(false);

  const toggleInputFields = (id) => {
    if (currentElementId == id) {
      setCurrentElementId('')
    } else {
      setCurrentElementId(id);
    }
  };

  const handleAppointmentStatus = (status) => {
    setAppointmentStatus(status);
  }

  const handleAppointmentTypes = (type) => {
    setAppointmentType(type);
  }

  const toggleReportGenerated = () => {
    setReportGenerated(!isReportGenerated)
  }

  return(
    <div className="w-full">
      {
        props.headerView && (
          <p className="fs-16 m-b-6 font-weight-700 color-black">Appointment Filter</p>
        )
      }
      <div onClick={()=>toggleInputFields('appointment-status')} className={`${currentElementId == "appointment-status" || appointmentStatus ? "member-global-input-field m-b-12 flex-item" : "member-global-input-field m-b-12 flex-item d-flex"}`} style={{ border: (currentElementId == "appointment-status" || appointmentStatus) ? "1px solid var(--darkBlue)" : "" }}>
        <div className="flex-item d-flex" style={{marginTop: (currentElementId == "appointment-status" || appointmentStatus) ? "4px" : "", marginBottom: (currentElementId == "appointment-status" || appointmentStatus) && "3.5px"}}>
          <p className="placeholder-txt flex-item" style={{ fontSize: (currentElementId == "appointment-status" || appointmentStatus) ? "10px" : "16px", lineHeight: (currentElementId == "appointment-status" || appointmentStatus) ? "10px" : "14px", color: (currentElementId == "appointment-status" || appointmentStatus) ? "var(--darkBlue)" : "", transition: "180ms" }}>Appointment Status</p>
        </div>
        <div className='input-field-arrow-dropdown' style={{ margin: "15px 12px 4px 0", transition: "180ms" }}>
          <svg className="flex-item" style={{ transform: currentElementId == "appointment-status" ? "rotate(180deg)" : "", transition: "180ms" }} width="13" height="8" viewBox="0 0 13 8" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1 1L6.5 6.5L12.5 1" stroke="var(--darkBlue)" stroke-linecap="round" />
          </svg>
        </div>
        <input id="appointment-status" className={`${(currentElementId == "appointment-status" || appointmentStatus) ? "active-input-field" : "inactive-input-field"} m-t-4 fs-16`} type="text" placeholder="Select" value={appointmentStatus ? appointmentStatus : ""} style={{ pointerEvents: "none", textTransform: 'capitalize' }} />
        {
          currentElementId == "appointment-status" && (
            <div className="global-input-field-arrow-dropdown global-input-field-arrow-dropdown-height-1 scaleFromTopToBottom" style={{background:"#f5f5f5", border: "1px solid #f5f5f5"}}>
              {
                allAppointmentStatus.map((status, index) => {
                  return (
                    <div onClick={()=>handleAppointmentStatus(status)} className="global-input-field-arrow-dropdown-item">
                      <p className="flex-item">{status}</p>
                    </div>
                  )
                })
              }
            </div>
          )
        }
      </div>
      <div onClick={()=>toggleInputFields('appointment-type')} className={`${currentElementId == "appointment-type" || appointmentType ? "member-global-input-field m-b-12 flex-item" : "member-global-input-field m-b-12 flex-item d-flex"}`} style={{ border: (currentElementId == "appointment-type" || appointmentType) ? "1px solid var(--darkBlue)" : "" }}>
        <div className="flex-item d-flex" style={{marginTop: (currentElementId == "appointment-type" || appointmentType) ? "4px" : "", marginBottom: (currentElementId == "appointment-type" || appointmentType) && "3.5px"}}>
          <p className="placeholder-txt flex-item" style={{ fontSize: (currentElementId == "appointment-type" || appointmentType) ? "10px" : "16px", lineHeight: (currentElementId == "appointment-type" || appointmentType) ? "10px" : "14px", color: (currentElementId == "appointment-type" || appointmentType) ? "var(--darkBlue)" : "", transition: "180ms" }}>Appointment Type</p>
        </div>
        <div className='input-field-arrow-dropdown' style={{ margin: "15px 12px 4px 0", transition: "180ms" }}>
          <svg className="flex-item" style={{ transform: currentElementId == "appointment-type" ? "rotate(180deg)" : "", transition: "180ms" }} width="13" height="8" viewBox="0 0 13 8" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1 1L6.5 6.5L12.5 1" stroke="var(--darkBlue)" stroke-linecap="round" />
          </svg>
        </div>
        <input id="appointment-type" className={`${(currentElementId == "appointment-type" || appointmentType) ? "active-input-field" : "inactive-input-field"} m-t-4 fs-16`} type="text" placeholder="Select" value={appointmentType ? appointmentType : ""} style={{ pointerEvents: "none", textTransform: 'capitalize' }} />
        {
          currentElementId == "appointment-type" && (
            <div className="global-input-field-arrow-dropdown global-input-field-arrow-dropdown-height-1 scaleFromTopToBottom" style={{background:"#f5f5f5", border: "1px solid #f5f5f5"}}>
              {
                allAppointmentTypes.map((type, index) => {
                  return (
                    <div onClick={()=>handleAppointmentTypes(type)} className="global-input-field-arrow-dropdown-item">
                      <p className="flex-item">{type}</p>
                    </div>
                  )
                })
              }
            </div>
          )
        }
      </div>
      <div className="d-flex m-t-20 m-b-20">
        <p className="flex-item fs-16 font-weight-700 m-r-12">Reports Generated</p>
        <div onClick={()=>toggleReportGenerated()} className='toggle-button d-flex' style={{backgroundColor: isReportGenerated && "#B3E28F"}}>
          <div className='toggle-ball flex-item' style={{right: isReportGenerated && 0, left: isReportGenerated && "auto", backgroundColor: isReportGenerated && "#5d883c"}} />
        </div>
      </div>
      <DateFilter/>
    </div>
  )
}

export default AppointmentFilter;